export const LOAD_APP_DATA = 'LOAD_APP_DATA'

export function loadAppData () {
	return {
		type: LOAD_APP_DATA
	}
}